<template>
  <div v-if="data?.logoFile || data?.label" class="clinic-branding-form-item">
    <div v-if="data?.logoFile" class="logo-container">
      <img :src="uploadedLogoUrl" :alt="data.label || 'Clinic Logo'" class="clinic-logo" />
    </div>
    <div v-if="data?.label" class="branding-title">{{ data.label }}</div>
  </div>
</template>

<script>
export default {
  name: 'ClinicBranding',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    uploadedLogoUrl() {
      console.log('uploadedLogoUrl', this.data.logoFile);
      return this.data.logoFile ? URL.createObjectURL(this.data.logoFile) : null;
    }
  }
};
</script>

<style scoped>
.clinic-branding-form-item {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.branding-title {
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
}

.logo-container {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clinic-logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
